import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import 'font-awesome/css/font-awesome.min.css'
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(ElementUI)
Vue.use(VideoPlayer)
Vue.config.productionTip = false
window.bus = new Vue();
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})

//登录拦截
router.beforeEach((to, from, next) => {
  if (to.path === '/register' || to.path === '/login' || to.path === '/' || to.path === '/rentContract') { //若是进入登录与注册页面 ==> pass
    if (from.path != '/rentContract') {
      next()
    }
  } else {
    let userToken = localStorage.getItem('token');
    if (userToken == null || userToken == '') {
      return next({//返回登录页面
        path: '/',
        query: {redirect: to.fullPath}
      })
    } else {
      next();
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js